module.exports = __webpack_public_path__ + "img/no-data.2c17e304.png";